import { render } from "./Cursos.vue?vue&type=template&id=18abd0b5&scoped=true"
import script from "./Cursos.vue?vue&type=script&lang=js"
export * from "./Cursos.vue?vue&type=script&lang=js"

import "./Cursos.vue?vue&type=style&index=0&id=18abd0b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18abd0b5"]])

export default __exports__